/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extracting_FramesInputs */

const en_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extracting frames (1fps)...`)
};

const fr_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraction des images (1 image/s)...`)
};

const de_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelbilder werden extrahiert (1 Bild pro Sekunde)...`)
};

const it_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrazione dei fotogrammi (1 fps)...`)
};

const ru_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Извлечение кадров (1 кадр в секунду)...`)
};

const es_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrayendo fotogramas (1 fps)...`)
};

const zh_cn2_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提取帧（1fps）...`)
};

const ja_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームを抽出中（1fps）...`)
};

const hi_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम निकाले जा रहे हैं (1fps)...`)
};

const pt_pt2_extracting_frames = /** @type {(inputs: Extracting_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraindo frames (1fps)...`)
};

/**
* | output |
* | --- |
* | "Extracting frames (1fps)..." |
*
* @param {Extracting_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const extracting_frames = /** @type {((inputs?: Extracting_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extracting_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_extracting_frames(inputs)
	if (locale === "de") return de_extracting_frames(inputs)
	if (locale === "it") return it_extracting_frames(inputs)
	if (locale === "ru") return ru_extracting_frames(inputs)
	if (locale === "es") return es_extracting_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_extracting_frames(inputs)
	if (locale === "ja") return ja_extracting_frames(inputs)
	if (locale === "hi") return hi_extracting_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_extracting_frames(inputs)
	return en_extracting_frames(inputs)
});